/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_unlimited': {
    width: 16,
    height: 16,
    viewBox: '0 0 477.867 477.867',
    data: '<path pid="0" d="M375.467 136.533c-53.333 0-110.933 51.661-136.533 77.534-25.6-25.873-83.2-77.534-136.533-77.534-64.119 0-102.4 38.281-102.4 102.4s38.281 102.4 102.4 102.4c53.333 0 110.933-51.661 136.533-77.534 25.6 25.873 83.2 77.534 136.533 77.534 64.12 0 102.4-38.281 102.4-102.4s-38.281-102.4-102.4-102.4zM102.4 307.2c-45.295 0-68.267-22.972-68.267-68.267s22.972-68.267 68.267-68.267c37.547 0 87.381 42.308 113.118 68.267C189.833 264.926 140.1 307.2 102.4 307.2zm273.067 0c-37.547 0-87.381-42.308-113.118-68.267 25.6-25.975 75.418-68.267 113.118-68.267 45.295 0 68.267 22.972 68.267 68.267S420.762 307.2 375.467 307.2z"/>'
  }
})
